import { render, staticRenderFns } from "./InsertEmoji.vue?vue&type=template&id=c4062cf8&scoped=true"
import script from "./InsertEmoji.vue?vue&type=script&lang=js"
export * from "./InsertEmoji.vue?vue&type=script&lang=js"
import style0 from "./InsertEmoji.vue?vue&type=style&index=0&id=c4062cf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4062cf8",
  null
  
)

export default component.exports